export const SET_EMAIL = 'signUp/SET_EMAIL';
